import { useContext } from 'react'

import { AppContext, AppContextType } from 'aem-libs-react-components/src/contexts/AppContextProvider'

import LanguageDetector from '../services/LanguageDetector'
import AppConfig from '../types/app-config'
import { Language } from '../types/common'


interface UseAppContextReturn<TStaticParams, TDynamicParams, TParamsFile>
  extends Required<Omit<AppContextType, 'paramsFile' | 'paramsStatic' | 'paramsDynamic'>> {
  language: Language
  paramsStatic: TStaticParams
  paramsDynamic: TDynamicParams
  paramsFile: TParamsFile
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useAppContext<
  TStaticParams = unknown,
  TDynamicParams = unknown,
  TParamsFile = AppConfig
>(): UseAppContextReturn<TStaticParams, TDynamicParams, TParamsFile> {
  const { paramsStatic, paramsDynamic, paramsFile, ...contextData } = useContext(AppContext)
  return {
    language: LanguageDetector(),
    paramsStatic: paramsStatic as TStaticParams,
    paramsDynamic: paramsDynamic as TDynamicParams,
    paramsFile: paramsFile as unknown as TParamsFile,
    ...(contextData as Required<Omit<AppContextType, 'paramsFile' | 'paramsStatic' | 'paramsDynamic'>>)
  }
}
